import React, { useEffect, useState } from "react";
import { ApiURL } from "../../../../../services/apiConstants";
import { post } from "../../../../../services/services";
import SisLoader from "../../../../../widgets/loader";
import BWTSDetailsTable from "../../components/CargoCraneCom/BwtsRow";

function StaffBWTS({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchBWTSList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_ship_bwts_details_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.response_data || []);
      }
    } catch (error) {
      console.error("Error fetching BWTS list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchBWTSList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>
        Ballast Water Treatment System (BWTS) Information
      </h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <BWTSDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffBWTS;
